import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { getTrainingDocumentFileName } from '../utils/documentFileName';

const TrainingDocumentPreviewDialog = ({ visible, onHide, document, previewUrl, loading }) => {
    const { th } = useLanguage();
    const viewerUrl = previewUrl ? `${previewUrl}#toolbar=0&navpanes=0&scrollbar=1` : '';

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header={getTrainingDocumentFileName(document) || th('lmsTrainingDocument.previewTitle')}
            modal
            maximizable
            resizable={false}
            style={{ width: '90vw', maxWidth: '90vw' }}
            breakpoints={{ '960px': '95vw' }}
            contentStyle={{ height: '80vh', padding: 0, overflow: 'hidden' }}
        >
            {loading && (
                <div className="flex align-items-center justify-content-center h-full">
                    <ProgressSpinner />
                </div>
            )}
            {!loading && viewerUrl && <iframe title={th('lmsTrainingDocument.previewTitle')} src={viewerUrl} style={{ width: '100%', height: '100%', display: 'block', border: 0 }} />}
            {!loading && !viewerUrl && <div className="flex align-items-center justify-content-center h-full p-4">{th('lmsTrainingDocument.previewError')}</div>}
        </Dialog>
    );
};

export default TrainingDocumentPreviewDialog;
